module.exports = ".copy-row .header h1,\n.copy-row .header h2,\n.copy-row .header h3,\n.copy-row .header h4 {\n  color: inherit; }\n\n.copy-row .copy p,\n.copy-row .copy pre {\n  margin-bottom: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/copy-row/copy-row.style.scss
// module id = 745
// module chunks = 2